import React from "react";
import { Link } from "react-router-dom";
import logo from "./img/logo.jpg";

function Home() {
  return (
    <div className="home">
      <div className="home__content">
        <img src={logo} alt="" className="home__logo" />
        <div className="home__links">
          <Link to="/signup">BE A MEMBER</Link>
          <Link to="/list">SEE OUR LIST</Link>
        </div>
      </div>
    </div>
  );
}

export default Home;
